import React, { useState, useEffect } from "react";
import AceEditor from "react-ace";

import "ace-builds/src-noconflict/mode-python";
import "ace-builds/src-noconflict/theme-tomorrow_night_bright";
import "ace-builds/src-noconflict/ext-language_tools";

import "./MainTask.css";

function CodeEditor({ taskData, code, setCode, course_name, user_id }) {
  const [isCorrect, setIsCorrect] = useState(null); // null, true, or false
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [PaiResponse, setPaiResponse] = useState(null);

  useEffect(() => {
    setCode(`# Пиши свой код сюда`);
    setIsCorrect(null);
    setLoading(false);
    setPaiResponse("");
  }, [taskData]);

  const handleEditorChange = (newValue) => {
    setCode(newValue);
  };

  const handleCheckSolution = async () => {
    setLoading(true);
    setError(null);
    setIsCorrect(null);
    setPaiResponse("");

    try {
      const response = await fetch("api/tasks/check", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          topic: taskData.topic,
          task_number: taskData.task_number,
          task_progress_id: taskData.task_progress_id,
          answer: code,
          course_name: course_name,
          user_id: user_id,
        }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      setPaiResponse(data.ai_response);
      if (typeof data.is_correct === "boolean") {
        setIsCorrect(data.is_correct);
      } else {
        throw new Error("Unexpected response data");
      }
    } catch (err) {
      setError("Произошла ошибка при проверке решения. Попробуйте еще раз.");
    } finally {
      setLoading(false);
    }
  };

  const closeFeedback = () => {
    setIsCorrect(null);
    setError(null);
    setPaiResponse("");
  };

  return (
    <div className="code-editor-frame">
      <div className="code-header">Code</div>
      <AceEditor
        mode="python"
        theme="tomorrow_night_bright"
        name="python_editor"
        onChange={handleEditorChange}
        fontSize={14}
        showPrintMargin={false}
        showGutter={true}
        highlightActiveLine={true}
        value={code}
        width="100%" /* Ensures full-width display */
        height="calc(100% - 40px)" /* Leaves space for the header */
        setOptions={{
          enableBasicAutocompletion: true,
          enableLiveAutocompletion: true,
          enableSnippets: true,
          showLineNumbers: true,
          tabSize: 2,
        }}
        className="ace-editor"
      />
      <button
        onClick={handleCheckSolution}
        className="submit-button"
        disabled={loading}
      >
        {loading ? "Проверка..." : "Отправить код на проверку"}
      </button>
      {/* <button className="next-button">Перейти к следующей</button> */}

      {/* Error Message */}
      {error && (
        <div className="error-message">
          {error}
          <button className="close-error" onClick={closeFeedback}>
            ✖
          </button>
        </div>
      )}

      {/* Feedback Block */}
      {isCorrect !== null && (
        <div
          className={`feedback-block ${
            isCorrect ? "feedback-correct" : "feedback-wrong"
          }`}
        >
          <div className="feedback-header">
            {isCorrect ? "Правильный ответ" : "Неправильный ответ"}
            <button className="close-feedback" onClick={closeFeedback}>
              ✖
            </button>
          </div>
          <div className="feedback-body">
            {isCorrect ? PaiResponse : PaiResponse}
          </div>
        </div>
      )}
    </div>
  );
}

export default CodeEditor;
